<template>
	<div class="auth side side-register">
		<div class="container">
			<div class="logo"></div>
			<h1>{{ $t('base.idicare.slogan_1') }}</h1>
			<h2>{{ $t('base.idicare.slogan_2') }}</h2>
			<div>{{ $t('base.auth.no_account') }}</div>
			<router-link :to="{ name: 'AuthRegister'}" class="btn btn-round btn-primary">{{ $t('base.auth.signup') }}</router-link>
		</div>
		<auth-static-content-links/>
		<locale-flag-selector/>
	</div>
</template>

<script>
import AuthStaticContentLinks from './AuthStaticContentLinks'
import LocaleFlagSelector from '@/components/i18n/LocaleFlagSelector'
export default {
	components: {
		AuthStaticContentLinks,
		LocaleFlagSelector
	}
}
</script>



// WEBPACK FOOTER //
// src/components/auth/SideRegister.vue